import React from 'react';

const PostMediaList = ({ articlesPlatform }) => {
  return (
    <div className='postmedia'>
      {articlesPlatform && articlesPlatform.length !== 0 && (
        <div className='postmedia__list'>
          <h2>
            Truyền thông nói gì <br /> về chúng tôi?
          </h2>
          {articlesPlatform.map(
            ({ slug, thumbnail, title, short_description }, index) => {
              if (index >= 2) {
                return '';
              }
              return (
                <article>
                  <a href={`/tin-tuc/${slug}`} className='img-thumb'>
                    <img src={thumbnail} alt='' />
                  </a>
                  <h3>
                    <a href={`/tin-tuc/${slug}`}>{title}</a>
                  </h3>
                  <p>{short_description}</p>
                  <a
                    href={`/tin-tuc/${slug}`}
                    title='Chi tiết'
                    className='link_viewmore'
                  >
                    Chi tiết
                  </a>
                </article>
              );
            }
          )}
        </div>
      )}
    </div>
  );
};

export default PostMediaList;
